<template>
    <v-card color="black" width="100%">
        <v-card-text class="white--text">
            <v-flex xs12 class="text-center">
                <b>Devolutivas NEC</b>
            </v-flex>
            <v-flex xs12 class="text-center" v-for="(devolution, index) in item.necDevolution" :key="index">
                <b>({{ devolution.statusCode }})</b> {{ devolution.statusDescription }}
                ({{ devolution.createdAt ? $moment(devolution.createdAt).format("DD/MM/YY HH:mm") : "---" }})
            </v-flex>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
};
</script>